<template>
  <v-app id="app">
    <Navbar />
    <Preload />
    <v-main>
      <v-container
        fluid
        class="app-home"
        style="max-width: 100%; padding: 0; overflow: hidden"
      >
        <transition
          name="fade"
          mode="out-in"
          @before-enter="beforeEnter"
          appear
        >
          <router-view />
        </transition>
        <v-snackbar
          v-model="snackWithButtons"
          bottom
          color="#da3838"
          rounded="pill"
          outlined
          centered
          timeout="-1"
        >
          {{ snackWithBtnText }}
          <template v-slot:action="{ attrs }">
            <v-btn
              text
              rounded
              outlined
              color="primary"
              v-bind="attrs"
              @click.stop="refreshApp"
            >
              <v-icon left>mdi-refresh</v-icon>
              {{ snackBtnText }}
            </v-btn>
            <v-btn icon class="ml-4">
              <v-icon color="#212121">mdi-bell-ring-outline</v-icon>
            </v-btn>
          </template>
        </v-snackbar>
      </v-container>
    </v-main>
    <Footer />
    <Navbottom />
  </v-app>
</template>

<script>
import Navbar from '@/components/Navbar'
import Preload from '@/components/Preload'
import Footer from '@/components/Footer'
import Navbottom from '@/components/Navbottom'
export default {
  name: 'App',
  data() {
    return {
      refreshing: false,
      registration: null,
      snackBtnText: '',
      snackWithBtnText: '',
      snackWithButtons: false,
    }
  },
  components: {
    Navbar,
    Preload,
    Footer,
    Navbottom,
  },
  async created() {
    document.addEventListener('swUpdated', this.showRefreshUI, { once: true })
    if (navigator.serviceWorker) {
      navigator.serviceWorker.addEventListener('controllerchange', () => {
        if (this.refreshing) return
        this.refreshing = true
        window.location.reload()
      })
    }
  },
  methods: {
    beforeEnter() {
      this.$root.$emit('scrollBeforeEnter')
    },
    showRefreshUI(e) {
      this.registration = e.detail
      this.snackBtnText = 'Refresh'
      this.snackWithBtnText = 'New update installed'
      this.snackWithButtons = true
    },
    refreshApp() {
      this.snackWithButtons = false
      if (!this.registration || !this.registration.waiting) {
        return
      }
      this.registration.waiting.postMessage('skipWaiting')
    },
  },
}
</script>
<style>
@import url('./assets/css/style.css');
.fade-enter,
.fade-leave-to {
  opacity: 0;
  transform: translateX(-2em);
}
.fade-enter-active,
.fade-leave-active {
  transition: all 0.2s ease-in-out;
}
</style>
